import { render, staticRenderFns } from "./bindBankCard.vue?vue&type=template&id=bf8a468c"
import script from "./bindBankCard.vue?vue&type=script&lang=js"
export * from "./bindBankCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports